/*
 *
 *  * Copyright(c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */
import { LogEntry, LogLevel } from './log-entry';

export class Logger {
  constructor(private source?: string) {}

  /**
   * Logs messages or objects  with the debug level.
   */
  debug(...objects: any[]) {
    LogEntry.log(this.source, console.log, LogLevel.DEBUG, objects);
  }

  /**
   * Logs messages or objects  with the info level.
   */
  info(...objects: any[]) {
    LogEntry.log(this.source, console.info, LogLevel.INFO, objects);
  }

  /**
   * Logs messages or objects  with the perf level.
   */
  perf(...objects: any[]) {
    LogEntry.log(this.source, console.info, LogLevel.PERF, objects);
  }

  /**
   * Logs messages or objects  with the warning level.
   */
  warn(...objects: any[]) {
    LogEntry.log(this.source, console.warn, LogLevel.WARN, objects);
  }

  /**
   * Logs messages or objects  with the error level.
   */
  error(...objects: any[]) {
    LogEntry.log(this.source, console.error, LogLevel.ERROR, objects);
  }

  private _callerName() {
    try {
      throw new Error();
    } catch (e) {
      try {
        const arr = e.stack.split('at ')[3].split(' ')[0].split('.');
        return `[${arr[arr.length - 2]} - ${arr[arr.length - 1]}::]`;
      } catch (e) {
        return '[]';
      }
    }
  }
}
